<template>
  <div style="margin: 10px">
    <v-card>
      <div class="headline dialog-header" >
        <v-toolbar color="primary" dark>
          <v-toolbar-title style="padding-left: 10px"
          >{{ $t(formName) }}
          </v-toolbar-title>
        </v-toolbar>
        <v-btn
            @click="onCancel"
            icon
            style="
                            position: absolute;
                            right: 10px;
                            top: 10px;
                            color: #fff;
                        "
        >
          <v-icon>cancel</v-icon>
        </v-btn>
      </div>
      <v-card-text>
        <v-layout wrap>
          <v-flex xs12 sm12 md4>
            <div style="padding: 20px 10px">
              <p class="font-weight-bold">
                Khu nuôi:
                {{areaCode}}
              </p>
            </div>
          </v-flex>
          <v-flex xs12 sm12 md4>
            <div style="padding: 20px 10px">
              <p class="font-weight-bold">
                Ngày xuất kho yêu cầu:
                {{formatDate(values.exportDate)}}
              </p>
            </div>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
    <v-tabs>
      <v-tabs-slider color="#2196F3"></v-tabs-slider>
      <v-tab>
        Tổng hợp

      </v-tab>
      <v-tab
          v-for="item in lstRequest"
          :key="item.exportId"
      >
        {{item.requestNumber}}-{{item.cropName}}

      </v-tab>

      <v-tabs-items>
        <v-tab-item>
          <export-request-summary-view :values-prop="values" :show-dialog-header="false"/>
        </v-tab-item>
        <v-tab-item
            v-for="item in lstRequest"
            :key="item.exportId"
        >
          <export-request-view :export-id="item.exportId" :show-dialog-header="false" :from-summary="true"/>
        </v-tab-item>
<!--        <v-tab-item>-->
<!--          -->
<!--        </v-tab-item>-->
<!--        <v-tab-item>-->
<!--          <export-request-view export-id="9" :show-dialog-header="false"/>-->
<!--        </v-tab-item>-->
      </v-tabs-items>
    </v-tabs>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import IDatepicker from "../../../components/form/DatePicker";
import {message} from "../../../shared/message";
import {areaContants, roleConstants} from "@/constants";
import ExportRequestView from "@/views/admin/export_request/ExportRequestView";
import ExportRequestSummaryView from "@/views/admin/export_request/ExportRequestSummaryView";

export default {
  name: "ExportRequestApprove",
  components: {ExportRequestSummaryView, ExportRequestView, IDatepicker, },
  props: {
    valuesProp: {
      type: Object,
      default: ()=> {}
    },
  },
  data: () => {
    return {
      formName: "Phê duyệt đề nghị xuất kho theo quy trình",
      loading: false,
      roleGroup: 2,
      values: {
          areaId: "-1",
          exportDate: ""
      },
      lstRequest: [],
      areaCode: '',
    };
  },

  created() {
    if(!this.isNull(this.valuesProp)
        && !this.isNullOrEmpty(this.valuesProp.areaId)
        && !this.isNullOrEmpty(this.valuesProp.exportDate)
        && !this.isNullOrEmpty(this.valuesProp.status)
       ){
      this.values.areaId = this.valuesProp.areaId;
      this.values.exportDate = this.valuesProp.requestDate;
      this.values.status = this.valuesProp.status;
      this.values.materialTypeAllyId = this.valuesProp.materialTypeAllyId;
    } else if(!this.isNullOrEmpty(this.$route.params.areaId)
        && !this.isNullOrEmpty(this.$route.params.requestDate)
        && !this.isNullOrEmpty(this.$route.params.status)){
      this.values.areaId = this.$route.params.areaId;
      this.values.exportDate = this.$route.params.requestDate;
      this.values.status = this.$route.params.status;
      this.values.materialTypeAllyId = this.$route.params.materialTypeAllyId;
    }

  },
  watch: {
    valuesProp: {
      handler(value) {
        this.values.areaId = value.areaId;
        this.values.exportDate = value.requestDate;
        this.values.status = value.status;
        this.values.materialTypeAllyId = value.materialTypeAllyId;
      },
      deep: true
    },
    values: {
      handler(value) {
        let tempValue = Object.assign({}, value, {"exportType": 1})
        this.getListRequest(tempValue);
        this.getPondArea(value.areaId);
      },
      deep: true
    },
  },

  methods: {
    onCancel() {
      this.$router.push({path: '/exportRequest'});
    },
    getPondArea(areaId) {
      axios.post(
          process.env.VUE_APP_API_URL + "/category/onSearchAllStatus?categoryTypeCode=PONDAREA&pageSize=-1&page=-1",
          {categoryId: areaId}
      )
          .then((data) => {
            if (data.items) {
              this.areaCode = data.items[0].categoryName;
              // this.getWarehouse(data.items[0].categoryId);
            }
          });
    },
    getListRequest(values) {
      if (values.areaId != -1) {
        const params = values;
        params.exportType = 1;
        axios
            .post(
                process.env.VUE_APP_API_URL + "/exportRequest/searchViewV3?pageSize=-1&page=-1",
                params
            )
            .then((data) => {
              if (data.items) {
                this.lstRequest=data.items;
              }
            });
      }
    },
    formatDate(date) {
      return moment(String(date)).format('DD/MM/YYYY');
    },
  },

  destroyed() {
  },
};
</script>
